"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExerciseInformation = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const ExerciseCardMobile_1 = require("./ExerciseCardMobile");
const ExerciseSeriesParameters_1 = require("./ExerciseSeriesParameters");
const ExerciseInformation = ({ translations, exerciseData, img }) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)("img", { src: img, alt: translations.imageAlt }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: translations.exerciseName }, void 0), (0, ExerciseCardMobile_1.setTrainingRatingTag)(exerciseData.exerciseRating || "", translations.rating)] }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: translations.exerciseDesc }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: translations.exerciseRest }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(ExerciseSeriesParameters_1.ExerciseSeriesParameters, { seriesData: exerciseData.seriesData }, void 0) }, void 0)] }, void 0));
};
exports.ExerciseInformation = ExerciseInformation;
const Wrapper = styled_components_1.default.div `
  display: flex;
  width: 100%;

  img {
    flex: 0;
    height: 87px;
    margin-right: ${({ theme }) => theme.spacings.m};
    width: 105px;
  }

  & > div {
    flex: 1;

    & > div {
      display: flex;

      & h2 {
        display: inline-block;
        margin-bottom: ${({ theme }) => theme.spacings.xs};
      }

      h2 + div {
        display: inline-block;
      }
    }
  }

  & > div:last-of-type {
    align-items: flex-start;
    align-self: flex-end;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;
    max-width: 400px;

    & > div {
      justify-content: space-between;
      width: 100%;
    }
  }

  & > div:last-of-type:empty {
    display: none;
  }
`;
//# sourceMappingURL=ExerciseInformation.js.map